
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import resolveMediaUrl from '../utils/mediaUrl';

const ContentDetail = ({ themeMode = 'night' }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [similar, setSimilar] = useState([]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/content/${id}`);
        setItem(response.data.item);
        // fetch similar items
        const simRes = await api.get('/content', {
          params: {
            section: response.data.item.section,
            category: response.data.item.category
          }
        });
        setSimilar((simRes.data.items || []).filter(i => i._id !== response.data.item._id));
      } catch (err) {
        setError('Зар олдсонгүй');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) return <div style={{ textAlign: 'center', margin: 40 }}>Уншиж байна...</div>;
  if (error) return <div style={{ textAlign: 'center', margin: 40 }}>{error}</div>;
  if (!item) return null;

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 32, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        {item.imageUrl && (
          <img
            src={resolveMediaUrl(item.imageUrl)}
            alt={item.title}
            style={{ width: 320, maxHeight: 260, objectFit: 'cover', borderRadius: 10, background: '#f8f8f8' }}
          />
        )}
        <div style={{ flex: 1, minWidth: 220 }}>
          <h2 style={{ fontWeight: 700, fontSize: 28, marginBottom: 12 }}>{item.title}</h2>
          {item.price && <div style={{ color: '#2563eb', fontWeight: 700, fontSize: 22, marginBottom: 12 }}>{Number(item.price).toLocaleString()}₮</div>}
          <div style={{ color: '#444', fontSize: 16, marginBottom: 16 }}>{item.description}</div>
          <div style={{ color: '#888', fontSize: 14, marginBottom: 8 }}>Ангилал: {item.category}</div>
          <div style={{ color: '#888', fontSize: 14 }}>Огноо: {new Date(item.createdAt).toLocaleDateString('mn-MN')}</div>
        </div>
      </div>
      {similar.length > 0 && (
        <div style={{ marginTop: 48 }}>
          <h3 style={{ fontWeight: 600, fontSize: 20, marginBottom: 18 }}>Ижил төрлийн зарууд</h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: 20
          }}>
            {similar.map(sim => (
              <div
                key={sim._id}
                style={{
                  background: '#fff',
                  border: '1px solid #eee',
                  borderRadius: 10,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  padding: 12,
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minHeight: 220
                }}
                onClick={() => navigate(`/content/${sim._id}`)}
              >
                {sim.imageUrl && (
                  <img
                    src={resolveMediaUrl(sim.imageUrl)}
                    alt={sim.title}
                    style={{ width: '100%', maxWidth: 140, maxHeight: 100, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }}
                  />
                )}
                <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 6, textAlign: 'center' }}>{sim.title}</div>
                {sim.price && <div style={{ color: '#2563eb', fontWeight: 600, fontSize: 15, marginBottom: 6 }}>{Number(sim.price).toLocaleString()}₮</div>}
                <div style={{ color: '#444', fontSize: 13, textAlign: 'center', maxHeight: 32, overflow: 'hidden', textOverflow: 'ellipsis' }}>{sim.description}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentDetail;
